import { Box } from "@mui/material";
import { Archive, Delete, Edit } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import KsbActionButton from "../../../2_ksbHub/components/KsbActionButton";

function SondertageActions({
  isASondertageEventAdmin,
  isTeacherView,
  selectedSonderEvent,
  actions, // ✅ pass full actions object
  dialogs, // ✅ pass dialog state
}) {
  const theme = useTheme();

  if (!isASondertageEventAdmin || isTeacherView || !selectedSonderEvent)
    return null;
  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        justifyContent: "flex-end",
        gap: 1,
      }}
    >
      <KsbActionButton
        onClick={() => {
          dialogs.setEditingSonderEvent(selectedSonderEvent);
          dialogs.setCreateSonderEventOpen(true);
        }}
        icon={<Edit />}
        label="SonderEvent Bearbeiten"
        sx={{ bgcolor: theme.palette.primary.main }}
      />

      <KsbActionButton
        onClick={() => actions.handleArchiveSonderEvent(selectedSonderEvent.id)}
        icon={<Archive />}
        label="Archivieren"
        sx={{ bgcolor: theme.palette.error.light }}
      />

      <KsbActionButton
        onClick={() => actions.handleDeleteSonderEvent(selectedSonderEvent.id)}
        icon={<Delete />}
        label="Löschen"
        confirm={{
          title: "Delete item?",
          message: "Are you sure you want to delete this item?",
        }}
        sx={{
          bgcolor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          "&:hover": { bgcolor: theme.palette.error.dark },
        }}
      />
    </Box>
  );
}

export default SondertageActions;
